<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import {
		celsius_to_fahrenheit,
		fahrenheit_to_celsius,
		isTRV,
		real_id,
	} from '../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Stores
		//Design system components
	import { Loader, Text, Token } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore,
		save = async () => {
			waitForResponse = true;
			let res: SettingRequest;
			if (device.type === 'SHDW-2') {
				res = await postReq(`/device/sensor/settings/set_command`, {
					id,
					set: `temperature_units`,
					command: selected,
				});
			} else {
				res = await postReq(`/device/sensor/settings/temperature`, {
					id,
					unit: selected,
				});
				if (res?.isok && isTRV(device?.type) && device?.temp_fav_positions) {
					const editDevice = {
						...device,
						temp_fav_positions: device?.temp_fav_positions.map((pos) => ({
							...pos,
							value:
								selected === 'C'
									? +fahrenheit_to_celsius(pos.value).toFixed(1)
									: celsius_to_fahrenheit(pos.value),
						})),
					};
					await requestEditDevice(editDevice);
				}
			}
			onSettingsResponse(res, device);
			waitForResponse = false;
		};

	let selected =
			(device.type === 'SHTRV-01'
				? settings?.thermostats[0]?.target_t.units
				: settings?.sensors?.temperature_unit) || 'C',
		waitForResponse = false;
</script>

<Text styleType="body-small" class="mb-s">
	{$format('select_temperature_units', {
		default: 'Choose temperature units:',
	})}
</Text>

<div
	class={classMap({
		'd-flex': true,
		'justify-content-center': waitForResponse,
	})}
>
	{#if waitForResponse}
		<Loader size="m" class="align-self-center" />
	{:else}
		<Token
			id="token-j1267e1"
			selected={selected === 'C'}
			size="m"
			title="°C"
			class="mr-s"
			on:click={() => {
				if (selected !== 'C') {
					selected = 'C';
					save();
				}
			}}
		/>
		<Token
			id="token-890qp19"
			selected={selected === 'F'}
			size="m"
			title="°F"
			on:click={() => {
				if (selected !== 'F') {
					selected = 'F';
					save();
				}
			}}
		/>
	{/if}
</div>
